// @ts-nocheck
import _ from 'lodash';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { makeStyles, Box, LinearProgress } from '@material-ui/core';
import { Catch, EmptyState, Panel } from '../../../../common/components';
import { selectPendingActions } from '../../../../common/state/pending';
import { selectAuthenticated } from '../../../auth';
import AppBar from './AppBar';
import AppDrawer from './AppDrawer';
import AppBreadcrumbs from './AppBreadcrumbs';
import { useIsFetching, useIsMutating } from '@tanstack/react-query'

const useStyles = makeStyles(theme => ({
  root: {
    flex: '1',
    display: 'flex',
    overflow: 'hidden',
  },
  container: {
    position: 'relative',
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  breadcrumbs: {
    borderTop: `1px solid ${theme.palette.divider}`,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  wrapper: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    padding: theme.spacing(3, 0),
  },
  content: {
    flex: '1',
    display: 'flex',
    minWidth: '1300px',
    '&::before': {
      content: '""',
      minWidth: theme.spacing(3),
    },
    '&::after': {
      content: '""',
      minWidth: theme.spacing(3),
    },
  },
  error: {
    flex: '1',
  },
  progress: {
    position: 'absolute',
    top: '0',
    right: '0',
    left: '0',
    zIndex: '9999',
  },
  toolbar: theme.mixins.toolbar,
}));

function AppLayout(props, error) {
  const [drawerOpen, setDrawerOpen] = useState(true);
  const [t] = useTranslation();
  const pendingActions = useSelector(selectPendingActions);
  const authenticated = useSelector(selectAuthenticated);
  const classes = useStyles();
  const isFetching = useIsFetching();
  const isMutating = useIsMutating();
  const isLoading = () => !_.isEmpty(pendingActions) || isFetching > 0 || isMutating > 0;

  const { children } = props;

  if (!authenticated) {
    return <Box className={classes.root}>{children}</Box>;
  }

  return (
    <Box className={classes.root}>
      <AppBar drawerOpen={drawerOpen} onDrawerOpen={() => setDrawerOpen(true)} />
      <AppDrawer drawerOpen={drawerOpen} onDrawerClose={() => setDrawerOpen(false)} />
      <Box className={classes.container}>
        {isLoading() && (
          <LinearProgress id="App-progressBar" className={classes.progress} />
        )}
        <Box className={classes.toolbar} />
        <Box className={classes.breadcrumbs}>
          <AppBreadcrumbs />
        </Box>
        <Box className={classes.wrapper}>
          <Box id="App-content" className={classes.content}>
            {error ? (
              <Panel id="App-error" variant="contained" className={classes.error}>
                <EmptyState variant="error" message={t('common.unexpectedError')} />
              </Panel>
            ) : (
              children
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

AppLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Catch(AppLayout);
